import { forwardRef } from "react";
import { StyledContent } from "./styled";
import { IChatContentProps } from "./types";

const Content = forwardRef<HTMLDivElement, IChatContentProps>((props, ref) => {
    const { children, ...rest } = props;

    return (
        <StyledContent ref={ref} {...rest}>
            {children}
        </StyledContent>
    );
});

Content.displayName = "ChatContent";

export { Content };
